/* eslint-disable react/forbid-foreign-prop-types */
const checkIfPropExistsInPropTypes = (props, component) => {
  if (
    props &&
    typeof props === "object" &&
    component.propTypes &&
    typeof component.propTypes === "object"
  )
    Object.keys(props).forEach((prop) => {
      if (!(prop in component.propTypes)) {
        console.error(
          `Warning: Failed prop type: The prop \`${prop}\` does not exist in \`${component.name}\`, but it's passed to the compoenent.`
        );
        return false;
      }
    });
};

export default checkIfPropExistsInPropTypes;
